module.exports = __webpack_public_path__ + "img/蓝猫.99ea6f47.gif";